import React, { useEffect, useState } from "react";
import styles from "../../../styles/valuechain/dashboard.module.css";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import { MenuItem, Select } from "@mui/material";
import Upstream from "../../../Components/ValueChain/Upstream";
import Downstream from "../../../Components/ValueChain/Downstream";
import { get } from "../../../utils/api";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import PeriodFilter from "../../../Components/Common/PeriodFilter";

const ValueChainDashboard = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const [page, setPage] = useState("Upstream");
  const [selectedPartner, setSelectedPartner] = useState("");
  const [upstreamPartners, setUpstreamPartners] = useState([]);
  const [downstreamPartners, setDownstreamPartners] = useState([]);
  const [selectedDownstreamPartner, setSelectedDownstreamPartner] =
    useState("");
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  useEffect(() => {
    if (page === "Upstream" && upstreamPartners.length > 0) {
      setSelectedPartner(upstreamPartners[0].id);
    } else if (page === "Downstream" && downstreamPartners.length > 0) {
      setSelectedDownstreamPartner(downstreamPartners[0].id);
    } else {
      setSelectedPartner("");
      setSelectedDownstreamPartner("");
    }
  }, [page, upstreamPartners, downstreamPartners]);

  const fetchPartner = async () => {
    try {
      let response = await get("/valueChain/dashboard/vendor/list");
      setUpstreamPartners(
        response?.data?.upstreamPartner.map((item) => {
          return {
            id: item._id,
            name: item.partnerCompany
              ? item?.partnerCompany?.companyName
              : item?.newPartnerName,
          };
        })
      );
      setDownstreamPartners(
        response?.data?.downstreamPartner.map((item) => {
          return {
            id: item._id,
            name: item.partnerCompany
              ? item?.partnerCompany?.companyName
              : item?.newPartnerName,
          };
        })
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchPartner();
  }, []);

  useEffect(() => {
    setSelectedPartner("");
    setSelectedDownstreamPartner("");
  }, [page]);

  // useEffect(() => {
  //   const currentDate = new Date();
  //   setMonth(String(currentDate.getMonth() + 1).padStart(2, "0"));
  //   setYear(currentDate.getFullYear());
  // }, []);

  const generateYearList = (startYear = 2020) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2020);

  const handlePageChange = async (pageName) => {
    setPage(pageName);
    await fetchPartner();
  };

  return (
    <MainDashboardLayout sidebar={<MainSidebar />}>
      <Unauthorized requiredModule="Value Chain | Dashboard">
        <>
          <div className={styles.heading_container}>
            <p className={styles.heading}>Emission From Value Chain</p>
            <div className={styles.selection_button}>
              <button
                className={
                  page === "Upstream"
                    ? styles.button_active
                    : styles.button_inactive
                }
                onClick={() => handlePageChange("Upstream")}
              >
                Upstream
              </button>
              <button
                variant="contained"
                className={
                  page === "Downstream"
                    ? styles.button_active
                    : styles.button_inactive
                }
                onClick={() => handlePageChange("Downstream")}
              >
                Downstream
              </button>
            </div>
            <div className={styles.partner_container}>
              <div>
                <p className={styles.dates_heading}>Company</p>
                <Select
                  sx={{
                    width: "225px",
                    height: "36px",
                    backgroundColor: "rgba(252, 252, 252, 1)",
                    borderRadius: "4px",
                    border: "1px solid rgba(0, 0, 0, 0.2)",
                  }}
                  size="small"
                  value={
                    page === "Upstream"
                      ? selectedPartner
                      : selectedDownstreamPartner || "Tap to select"
                  }
                  onChange={(e) => {
                    if (page === "Upstream") {
                      setSelectedPartner(e.target.value);
                    } else if (page === "Downstream") {
                      setSelectedDownstreamPartner(e.target.value);
                    }
                  }}
                >
                  <MenuItem value="Tap to select" disabled>
                    Tap to select
                  </MenuItem>
                  {(page === "Upstream"
                    ? upstreamPartners
                    : downstreamPartners
                  ).map((item) => (
                    <MenuItem key={item?.id} value={item?.id}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <PeriodFilter
                {...{
                  fromDate,
                  setFromDate,
                  toDate,
                  setToDate,
                  yearList,
                  facilityRequired: "false",
                }}
              />
            </div>
          </div>

          {page === "Upstream" ? (
            <Upstream
              valueChainId={selectedPartner}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : page === "Downstream" ? (
            <Downstream
              valueChainId={selectedDownstreamPartner}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : null}
        </>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default ValueChainDashboard;
